   
<template>
  <div class="market_left hk_stock">
    <div class="">
      <stock-chart></stock-chart>
    </div>
    <div class="divideSection"></div>
    <div>
      <el-row>
        <el-col :span="24" style="padding: 10px"> 港股成交额 </el-col>
      </el-row>
    </div>
    <div class="wrap">
      <div class="main">
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          style="width: 100%"
        >
          <el-table-column fixed align="center" label="代码">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol: 'hk' + scope.row.symbol,direction:0 },
                }"
                class="stockLinkColor"
              >
                <span>{{ scope.row.symbol }}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column fixed align="center" prop="name" label="名称">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol: 'hk' + scope.row.symbol,direction:0 },
                }"
                class="stockLinkColor"
              >
                <span
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  >{{ scope.row.name }}</span
                >
              </router-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="lasttrade" label="最新价">
          </el-table-column>
          <el-table-column align="center" prop="pricechange" label="涨跌额">
          </el-table-column>
          <el-table-column align="center" prop="changepercent" label="涨跌幅">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.changepercent).toFixed(3) }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="buy" label="买入">
          </el-table-column>
          <el-table-column align="center" prop="sell" label="卖出">
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="settlement"
            label="昨收">
          </el-table-column> -->
          <el-table-column align="center" prop="open" label="今开">
          </el-table-column>
          <el-table-column align="center" prop="high" label="最高">
          </el-table-column>
          <el-table-column align="center" prop="low" label="最低">
          </el-table-column>
          <!--<el-table-column
            align="center"
            width="120"
            prop="volume"
            label="成交量/手">
            <template slot-scope="scope">
              <span>{{ scope.row.volume.toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="120"
            prop="amount"
            label="成交额/万">
            <template slot-scope="scope">
              <span>{{ scope.row.amount.toLocaleString() }}</span>
            </template>
          </el-table-column>-->
        </el-table>
        <div class="pagination" v-if="total>pagesize">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="this.pagesize"
          >
          </el-pagination>
        </div>
        <div class="bottombar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import StockChart from "@/components/stockchart";
export default {
  name: "HKStockTurnover",
  components: {
    StockChart,
  },
  data() {
    return {
      tableData: [],
      total: 40,
      currentPage: 1,
      pagesize: 40,
    };
  },
  methods: {
    get_hk_turnover() {
      let that = this;
      $.ajax({
        cache: true,
        url:
          "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
          that.currentPage +
          "&num=" +
          that.pagesize +
          "&sort=amount&asc=0&node=qbgg_hk&_s_r_a=init",
        type: "GET",
        dataType: "json",
        success: function (data) {
          that.tableData = data;
        },
      });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.get_hk_turnover();
    },
    getTableCount() {
      let that = this;
      $.ajax({
        cache: true,
        url: "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockCount?node=qbgg_hk",
        type: "GET",
        dataType: "json",
        success: function (data) {
          that.total = parseInt(data);
        },
      });
    },
  },
  mounted: function () {
    let that = this;
    that.getTableCount();
    that.get_hk_turnover();
  },
};
</script>

<style scoped>
.main {
  margin-top: 10px;
}
.stockLinkColor {
  color: rgb(0, 0, 238);
}
.stockLinkColor :hover {
  color: #0100a0;
}
.green {
  color: #008000;
}
.bottombar {
  margin: 0 auto;
  text-align: center;
  padding-top: 10px;
}
.divideSection {
  height: 10px;
  background: #f1f1f1;
}
.hk_stock {
  border-left: 10px #f1f1f1 solid;
}
.pagination {
  margin: 0 auto;
  text-align: center;
}

.market_left {
  width: 1000px;
  float: right;
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/HKStockTurnover.vue